attribute vec2 offset;

varying vec2 vOffset;

void main() {

    vOffset = offset;


    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    
    gl_PointSize = 300.0 - (length(position.xyz) / 100.0);
}